export enum V2CardAgentToolName {
  //General tools
  ReadValuesFromExcel = 'readValuesFromExcel',
  GetCardDetails = 'getCardDetails',
  SetCardName = 'setCardName',
  SetCardDescription = 'setCardDescription',
  DeleteOutputs = 'deleteOutputs',

  //Condition card tools
  SearchSignal = 'searchSignal',
  SetSignal = 'setSignal',
  SetOperator = 'setOperator',
  SearchFeedValues = 'searchFeedValues',
  AddOrUpdateConditionCard = 'addOrUpdateConditionCard',
  AddConditionOutput = 'addConditionOutput',
  UpdateConditionOutput = 'updateConditionOutput',
  RemoveConditionOutput = 'removeConditionOutput',
  SubmitCard = 'submitCard',

  //Schedule card tools
  AddOrUpdateScheduleCard = 'addOrUpdateScheduleCard',
  SetScheduleType = 'setScheduleType',
  SetTimezoneSource = 'setTimezoneSource',
  SetTimeZone = 'setTimeZone',
  SetRandomizeOutputs = 'setRandomizeOutputs',
  AddScheduleOutput = 'addScheduleOutput',
  EditScheduleOutput = 'editScheduleOutput',

  //Weighted card tools
  AddOrUpdateWeightedCard = 'addOrUpdateWeightedCard',
  SetShouldSplitAudience = 'setShouldSplitAudience',
  AddWeightedOutput = 'addWeightedOutput',
  EditWeightedOutput = 'editWeightedOutput',
  DeleteWeightedOutputs = 'deleteWeightedOutputs',

  //Optimization card tools
  AddOrUpdateOptimizationCard = 'addOrUpdateOptimizationCard',
  SetOptimizeBy = 'setOptimizeBy',
  SetOptimizeAcross = 'setOptimizeAcross',
  SetOutputsCount = 'setOutputsCount',
  SetOptimizationGoal = 'setOptimizationGoal',
  GetOptimizeByOptions = 'getOptimizeByOptions',
  SetAttributionSignals = 'setAttributionSignals',
  GetAttributionSignals = 'getAttributionSignals',
}
